module.exports = __webpack_public_path__ + "img/uestc-sz-logo.b1993f72.png";